import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,   // es-MX → es, en-US → en, etc.
    supportedLngs: ['en', 'es', 'ar'],
    backend: {
      // path to load translation files
      loadPath: '/locales/{{lng}}/{{ns}}.yml',
      parse: (data) => {
        // parse YAML files
        const yaml = require('js-yaml');
        return yaml.load(data);
      },
    },
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    ns: ['common'],
    defaultNS: 'common',
      detection: {
      order: ['localStorage', 'navigator'],
      caches: [],
    }
  });

export default i18n;